import { _ } from '../../vendor';
import InboomaBaseModel from './InboomaBaseModel';
import Events from '../collections/Events';
import Contingents from '../collections/Contingents';

export default InboomaBaseModel.extend({

    urlRoot : '/calendars',

    initialize : function() {
      // Merge events- & contingents-data into actual collection
      this.set('events', new Events(this.get('events')));
      this.set('contingents', new Contingents(this.get('contingents')));
    },

    _rbac : {
      "admin" : {
        "read" : true,
        "write" : true,
        "edit" : true,
        "remove" : true,
      },
      "user" : {
        "read" : false,
        "write" : false,
        "edit" : false,
        "remove" : false
      }
    },

    defaults : {
      id: "",
      client_id : "",
      name : "",
      contingents : [],
      events : [],
      description : "",
      created: "",
      modified: "",
      deleted: null
    }
});